import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
    fetchTypeaheadUsers,
    clearTypeahed
} from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class UsersMultiTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadUsers: PropTypes.func,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number, PropTypes.object]),
        id: PropTypes.string,
        labelId: PropTypes.string,
        animatedPlaceholder: PropTypes.bool,
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        labelId: 'user',
        renderMultiSuggestion
    };

    constructor(props) {
        super(props);
        this.fetchUsers = this.props.fetchTypeaheadUsers;
    }

    handleSuggestionsFetchRequested = term => {
        const statusEmployeeState =
        this.props.isDismissedEmployees ? { EmployeeStates: 'NotEmployed' } : undefined;
        this.fetchUsers(UsersMultiTypeahead.name, {
            term,
            locationsQuery: this.locationsQuery,
            id: this.props.id
        }, statusEmployeeState);
    };

    render() {

        const { suggestions,
            value,
            animatedPlaceholder,
            onChangeSuggestion,
            clearTypeahed,
            renderMultiSuggestion,
            isMulti = true,
            isClearable = false,
            isDisabled = false,
            required,
            error,
            labelId,
            t } = this.props;

        const options = suggestions?.map(user => ({
            label: user.userName,
            value: user.id
        }));

        return (
            <MultiTypeahead
                isRequired={required}
                options={options}
                value={value}
                isClearable={isClearable}
                disabled={isDisabled}
                animatedPlaceholder={animatedPlaceholder}
                selectFilterOption={() => true}
                handleSuggestionsClearRequested={clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={onChangeSuggestion}
                formatOptionLabel={renderMultiSuggestion}
                error={error}
                isMulti={isMulti}
                titleId={labelId}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === UsersMultiTypeahead.name ?
            typeahead.list.users : UsersMultiTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadUsers,
    clearTypeahed
})(UsersMultiTypeahead);
